import LocalNotification from '@libs/Notification/LocalNotification';
import ClearReportNotifications from './types';

const clearReportNotifications: ClearReportNotifications = LocalNotification.clearReportNotifications;
export default clearReportNotifications;
